"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddEthereumChainParameters = void 0;
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const chainConfiguration_1 = require("../../../lib/chainConfiguration");
function getAddEthereumChainParameters(chainId) {
    const hexChainId = '0x' + chainId.toString(16);
    const chainName = (0, chain_id_1.getChainName)(chainId);
    const config = (0, chainConfiguration_1.getChainConfiguration)(chainId);
    switch (chainId) {
        case chain_id_1.ChainId.MATIC_MAINNET:
            return {
                chainId: hexChainId,
                chainName,
                nativeCurrency: {
                    name: 'MATIC',
                    symbol: 'MATIC',
                    decimals: 18
                },
                rpcUrls: ['https://rpc-mainnet.maticvigil.com/'],
                blockExplorerUrls: ['https://polygonscan.com/']
            };
        case chain_id_1.ChainId.MATIC_MUMBAI:
            return {
                chainId: hexChainId,
                chainName,
                nativeCurrency: {
                    name: 'MATIC',
                    symbol: 'MATIC',
                    decimals: 18
                },
                rpcUrls: ['https://rpc-mumbai.maticvigil.com/'],
                blockExplorerUrls: ['https://mumbai.polygonscan.com/']
            };
        case chain_id_1.ChainId.ETHEREUM_MAINNET:
        case chain_id_1.ChainId.ETHEREUM_ROPSTEN:
        case chain_id_1.ChainId.ETHEREUM_RINKEBY:
        case chain_id_1.ChainId.ETHEREUM_KOVAN:
        case chain_id_1.ChainId.ETHEREUM_GOERLI:
        case chain_id_1.ChainId.ETHEREUM_SEPOLIA:
            return {
                chainId: hexChainId,
                chainName,
                nativeCurrency: {
                    name: 'Ether',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [config.rpcURL],
                blockExplorerUrls: ['https://etherscan.io']
            };
    }
}
exports.getAddEthereumChainParameters = getAddEthereumChainParameters;
//# sourceMappingURL=getAddEthereumChainParameters.js.map